import { TTranslation } from '@shared/types';

export const trLegoThemes: TTranslation = {
  DE: 'LEGO® Themenwelten',
  EN: 'LEGO® Themes',
  FR: 'LEGO® Thèmes',
};
